/**
 * Expõe se o gate de onboarding já resolveu o progresso inicial.
 * O layout autentica usa isso para não revelar o dashboard antes do redirect.
 */
import { createContext, useContext } from 'react';

export type OnboardingGateContextValue = {
  /** false enquanto o progresso inicial ainda não foi resolvido */
  isGateReady: boolean;
};

const OnboardingGateContext = createContext<OnboardingGateContextValue>({
  isGateReady: true,
});

export const OnboardingGateProvider = OnboardingGateContext.Provider;

export function useOnboardingGate(): OnboardingGateContextValue {
  return useContext(OnboardingGateContext);
}
